<template>
  <div
       @mouseover="handleMouseOver($event)"
       @mouseout="handleMouseOut($event)">
    <img ref="img" :class="[{'disabled': !isEnabled}, 'prefetch']" :src="images.imageSrc">
  </div>
</template>

<script>
    export default {
      name: "hoverable-image",
      props: {
        images: {
          required: true,
          type: Object,
        },
        isEnabled: {
          default: true,
          type: Boolean,
        },
        isSelected: {
          default: false,
          type: Boolean,
        },
      },
      mounted() {
        if (!this.isEnabled) {
          window.preloader.setImage(this.$refs.img, this.images.imageDisable);
        } else if (this.isSelected) {
          window.preloader.setImage(this.$refs.img, this.images.imageSelected);
        }
      },
      methods: {
        handleMouseOver(e) {
          const bg = e.target;
          if (this.isEnabled && this.images.imageOver && !this.isSelected) {
            window.preloader.setImage(bg, this.images.imageOver);
          }
        },
        handleMouseOut(e) {
          const bg = e.target;
          if (this.isEnabled && !this.isSelected) {
            window.preloader.setImage(bg, this.images.imageSrc);
          }
        },
      },
      watch: {
        isEnabled: function (newVal, oldVal) { // watch it
          // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
          if (!newVal) {
            window.preloader.setImage(this.$refs.img, this.images.imageDisable);
            this.$refs.img.classList.add('disabled');
          } else {
            window.preloader.setImage(this.$refs.img, this.images.imageSrc);
            this.$refs.img.classList.remove('disabled');
          }
        },
        isSelected: function (newVal, oldVal) { // watch it
          // console.log('isSelected changed: ', newVal, ' | was: ', oldVal);
          if (newVal) {
            window.preloader.setImage(this.$refs.img, this.images.imageSelected);
          } else {
            window.preloader.setImage(this.$refs.img, this.images.imageSrc);
          }
        },
      },
    };
</script>

<style scoped>
  .disabled {
    cursor: initial;
  }

  img {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Hoverable-Image.vue?547e1f0a